import React from "react";
import { Alert, Button, Grid } from "@mui/material";
import { useParams, useHistory } from "react-router-dom";
import LabeledSelect, { SelectOption } from "../../Widgets/LabeledSelect";
import LabeledTextArea from "../../Widgets/LabeledTextArea";
import { CrisisPlanFormValues } from "./interface";

interface EditFieldsProps {
  formValues: CrisisPlanFormValues;
  handleChange: (
    field: keyof CrisisPlanFormValues
  ) => (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  handleBehaviorsChange: (value: string[]) => void;
  behaviorsOptions: SelectOption[];
  hasSafetyConcerns: boolean;
}

export const EditFields: React.FC<EditFieldsProps> = ({
  formValues,
  handleChange,
  handleBehaviorsChange,
  behaviorsOptions,
  hasSafetyConcerns,
}) => {
  const { id: clientId } = useParams<{ id: string }>();
  const history = useHistory();
  return (
    <Grid container spacing={7}>
      <LabeledSelect
        label="Does the client need a crisis plan?"
        value={formValues.hasCrisisPlan}
        onChange={handleChange("hasCrisisPlan")}
      />

      <LabeledTextArea
        multiline
        minRows={3}
        label="Crisis plan"
        value={formValues.crisisPlan}
        onChange={handleChange("crisisPlan")}
      />

      <LabeledSelect
        label="Behaviors identified"
        multiple
        value={formValues.behaviorsIdentified}
        onChange={handleBehaviorsChange}
        options={behaviorsOptions}
        disabled={!hasSafetyConcerns && formValues.behaviorsIdentified.length === 0}
      />

      <Grid item xs={12}>
        <Alert
          severity={hasSafetyConcerns ? "info" : "warning"}
          action={
            <Button
              color={hasSafetyConcerns ? "info" : "warning"}
              size="small"
              variant="text"
              onClick={() => history.push(`/clients/${clientId}/strengths-and-areas-of-need`)}
            >
              {hasSafetyConcerns ? "View Safety Concerns" : "Add Safety Concerns"}
            </Button>
          }
        >
          {hasSafetyConcerns
            ? "These behaviors are based on the safety concerns documented in the client's profile."
            : "No safety concerns have been recorded for this client. Add safety concerns to populate the behaviors list."}
        </Alert>
      </Grid>

      <LabeledTextArea
        multiline
        minRows={3}
        label="Additional considerations"
        value={formValues.additionalConsiderations}
        onChange={handleChange("additionalConsiderations")}
      />
    </Grid>
  );
};

export default EditFields;
